/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { YardDateField } from "../../../components/common/YardDateField";

import { useSearchableList } from "../../../dataProvider/useSearchableList";

import {
  Box,
  Card,
  Divider,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { differenceInDays } from "date-fns";

import {
  BulkActionsToolbar,
  Datagrid,
  EditButton,
  FilterButton,
  FunctionField,
  ListContextProvider,
  RefreshButton,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";
import { FilterContext, FilterForm } from "ra-ui-materialui";
import { Form } from "react-final-form";

import { ChevronRightIcon } from "../../../components/common/iconography";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { SearchField } from "../../../components/common/SearchField";
import { ListDatePicker } from "../../../components/common/ListDatePicker";
import ExportDropDown from "../../../components/common/ExportDropDown";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";

import { isSubscriptionDisabled } from "../../../utils/appUtils";
import { InboundStatus } from "../../../utils/constants";
import { exceptionRenderer, normalizeValue } from "../../../utils/utils";

// SIT list renders inboundShipment records, so it reuses the canonical
// inboundShipments components rather than maintaining trackCars-local copies.
import { EmptyInbound } from "../inboundShipments/EmptyInbound";
import { AdvanceButton } from "../inboundShipments/AdvanceButton";
import { InboundStateIcon } from "../inboundShipments/InboundStateIcon";
import {
  inboundExportCsv,
  inboundExportPdf,
} from "../inboundShipments/InboundExports";
import CreateMenuButton from "../inboundShipments/CreateMenuButton";
import { BulkAdvanceButton } from "./BulkAdvanceButton";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  bulkActions: {
    // [classes.bulkActions] remove to restore original behavior
    marginTop: -theme.spacing(8),
    transition: theme.transitions.create("margin-top"),
  },
}));

const useToolbarStyles = makeStyles(
  (theme) => ({
    toolbar: {
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingRight: 0,
      [theme.breakpoints.up("xs")]: {
        paddingLeft: 0,
      },
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(2),
      },
    },
    leftControlsXs: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(2),

        // Make FilterForm inputs span full width on mobile
        "& [class*='RaFilterForm-form']": {
          width: "100%",
        },
        "& .filter-field": {
          width: "100%",
          flexBasis: "100%",
          flexGrow: 1,
        },
        // Remove the trailing spacer that prevents full-width controls
        "& .filter-field > div:last-child": {
          display: "none",
        },
      },
    },
  }),
  { name: "InboundListToolbar" },
);

const tabs = [
  {
    id: InboundStatus.SIT_PENDING,
    name: "Pending",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.SIT_PLACED,
    name: "PLACED",
    sortKey: "placedDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
];

const InboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const normalizedValue = normalizeValue(value);
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { carrierName: { matchPhrasePrefix: `${value}` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (smDown, tabValue) => {
  const filters = [
    <InboundSearchField label="Search" tabValue={tabValue} alwaysOn />,
  ];

  // The Placed Date filter only applies to the SIT_PLACED tab — Pending cars
  // have no placedDateTime (they sort/display scheduledDateTime).
  if (tabs[tabValue]?.id === InboundStatus.SIT_PLACED) {
    filters.push(
      <ListDatePicker
        label="Date received"
        source="placedDateTime"
        filterField="placedDateTime"
      />,
    );
  }

  return filters;
};

// SIT age = whole days the car has been placed (based on placedDateTime).
const sitAgeRenderer = (record) =>
  record?.placedDateTime
    ? differenceInDays(new Date(), new Date(record.placedDateTime))
    : "";

const BulkListActions = ({ tabValue }) => (
  <BulkAdvanceButton tabValue={tabValue} />
);

const InboundListToolbar = (props) => {
  const {
    filters,
    actions,
    selectedAccountId,
    onAccountChange,
    xsDown,
    ...rest
  } = props;
  const classes = useToolbarStyles(props);

  return Array.isArray(filters) ? (
    <FilterContext.Provider value={filters}>
      <Toolbar className={classes.toolbar}>
        <Box
          display="flex"
          alignItems="flex-start"
          flexWrap="wrap"
          flexDirection={xsDown ? "column" : "row"}
          width={xsDown ? "100%" : undefined}
          className={xsDown ? classes.leftControlsXs : undefined}
        >
          <Form
            key={selectedAccountId || "account-all"}
            onSubmit={() => {}}
            initialValues={{ accountId: selectedAccountId || "" }}
            keepDirtyOnReinitialize
            render={() => (
              <Box
                mt={1}
                mr={xsDown ? 0 : 2}
                width={xsDown ? "100%" : undefined}
              >
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  alwaysOn
                  helperText={false}
                  onAccountChange={onAccountChange}
                />
              </Box>
            )}
          />
          <FilterForm />
        </Box>
        <span />
        {actions &&
          React.cloneElement(actions, {
            ...rest,
            filters, // IMPORTANT: FilterButton expects an array
            ...actions.props,
          })}
      </Toolbar>
    </FilterContext.Provider>
  ) : null;
};

const ListActions = (props) => {
  const { xsDown } = props;
  const { resource, total } = useListContext();

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <CreateMenuButton
        resource={resource}
        disabled={isSubscriptionDisabled()}
        sit
      />
      <ExportDropDown
        total={total}
        resource={resource}
        exporter={inboundExportCsv}
        exporterPdf={inboundExportPdf}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSortOrder = (tabIndex) => {
  return tabs[tabIndex].sortOrder;
};

const getSortByWithScope = (tabValue, selectedAccountId) => {
  const tabIndex = tabs.findIndex((tab) => tab.id === tabValue);
  const key = selectedAccountId
    ? "inboundShipmentByAccountByStatusByDates"
    : "inboundShipmentByReloadYardByStatusByDates";
  return `{"key":"${key}", "search":"${tabs[tabIndex].sortKey}"}`;
};

const getDefaultFilterWithScope = (tabIndex, selectedAccountId) => {
  const statusFilter = {
    beginsWith: {
      status: tabs[tabIndex].id,
    },
  };

  if (selectedAccountId) {
    return {
      accountId: selectedAccountId,
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
        statusFilter,
    };
  }

  return {
    reloadYardId: window.appUser.reloadYardId,
    statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
      statusFilter,
  };
};

const getDefaultSearchFilterWithScope = (tabIndex, selectedAccountId) => {
  const tabId = tabs[tabIndex].id;

  if (selectedAccountId) {
    return {
      accountId: { eq: selectedAccountId },
      status: { eq: tabId },
    };
  }

  return {
    reloadYardId: { eq: window.appUser?.reloadYardId },
    status: { eq: tabId },
  };
};

const getSessionTab = () => {
  const sessionTab = Number(sessionStorage.getItem(`SITTab`));
  if (sessionTab && tabs[sessionTab]) {
    return sessionTab;
  }
  return 0; // Default to the first visible tab if the sessionTab is not valid
};

export const InboundList = (props) => {
  const classes = useStyles();
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [tabIndex, setTabIndex] = useState(getSessionTab());
  const reloadYardId = window.appUser?.reloadYardId;
  const accountStorageKey = `${props.resource}_${reloadYardId}_accountId`;
  const storedAccountId = localStorage.getItem(accountStorageKey);
  const [selectedAccountId, setSelectedAccountId] = useState(
    storedAccountId || null,
  );

  const [defaultFilter, setDefaultFilter] = useState(() =>
    getDefaultFilterWithScope(tabIndex, selectedAccountId),
  );
  const [defaultSearchFilter, setDefaultSearchFilter] = useState(() =>
    getDefaultSearchFilterWithScope(tabIndex, selectedAccountId),
  );
  // Include key & search to display default sort order.
  const defaultSort = {
    field: getSortByWithScope(tabs[tabIndex].id, selectedAccountId),
    order: getSortOrder(tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "SIT",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "inboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // reset list on automatic stale list reset
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  const applyScopedDefaults = (nextTabIndex, nextAccountId) => {
    setDefaultFilter(getDefaultFilterWithScope(nextTabIndex, nextAccountId));
    setDefaultSearchFilter(
      getDefaultSearchFilterWithScope(nextTabIndex, nextAccountId),
    );
    listContext.setSort(
      getSortByWithScope(tabs[nextTabIndex].id, nextAccountId),
      getSortOrder(nextTabIndex),
    );
    listContext.setPage(1);
    const nextFilterValues = listContext.filterValues || {};
    listContext.setFilters(
      { ...nextFilterValues },
      listContext.displayedFilters,
    );
  };

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    applyScopedDefaults(value, selectedAccountId);
  };

  const handleAccountChange = (selectedAccount) => {
    const nextAccountId = selectedAccount?.id || null;
    setSelectedAccountId(nextAccountId);
    if (nextAccountId) {
      localStorage.setItem(accountStorageKey, nextAccountId);
    } else {
      localStorage.removeItem(accountStorageKey);
    }
    applyScopedDefaults(tabIndex, nextAccountId);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="SIT" />} />
      <InboundListToolbar
        {...props}
        filters={getListFilters(smDown, tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
        xsDown={xsDown}
        selectedAccountId={selectedAccountId}
        onAccountChange={handleAccountChange}
      />
      <Card
        className={classnames(classes.listRoot, {
          [classes.bulkActions]: listContext.selectedIds.length > 0,
        })}
      >
        <BulkActionsToolbar>
          <BulkListActions tabValue={tabs[tabIndex].id} />
        </BulkActionsToolbar>
        <ShipmentTabs
          {...props}
          {...listContext}
          selectedAccountId={selectedAccountId}
          tabValue={tabIndex}
          setTabValue={handleTabChange}
          xsDown={xsDown}
          smDown={smDown}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({
  selectedAccountId,
  tabValue,
  setTabValue,
  setPage,
  ...props
}) => {
  const { smDown } = props;

  const handleChange = (event, value) => {
    sessionStorage.setItem("SITTab", value);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!smDown || itm.showSmall) && (
              <Tab
                value={idx}
                key={itm.id}
                label={itm.name}
                id={`shipment-${idx}`}
              />
            ),
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <ShipmentGrid
              {...props}
              key={itm.id}
              selectedAccountId={selectedAccountId}
              tabValue={itm.id}
            />
          ),
      )}
    </>
  );
};

const ShipmentGrid = ({ ids, page, selectedAccountId, tabValue, ...props }) => {
  const { xsDown, smDown } = props;
  // const accountFields = account?.inventoryCustomFields?.length > 0 ? account.inventoryCustomFields : [];
  // const customGridFields = accountFields ? accountFields.map((field, index) => {
  //     return <CustomField source={`customFields[${index}]`} field={field} label={field.name} sortable={true} />
  // }) : [];

  if (tabValue === InboundStatus.SIT_PENDING && ids.length === 0 && page === 1)
    return (
      <EmptyInbound
        {...props}
        message="Create a new SIT Inbound"
        state={{ sit: true }}
      />
    );
  else
    return xsDown ? (
      <SimpleList
        primaryText={(record) =>
          record.account?.displayName ?? record.accountName
        }
        secondaryText={(record) => `Car/Trl No:: ${record.railCarNumber}`}
        tertiaryText={(record) => record.placedDateTime}
        leftIcon={(record) => <InboundStateIcon record={record} />}
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
        linkType="edit"
      />
    ) : smDown ? (
      <Datagrid rowClick="edit">
        {tabValue === InboundStatus.SIT_PLACED ? <InboundStateIcon /> : null}
        {tabValue === InboundStatus.SIT_PLACED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={exceptionRenderer}
          />
        ) : null}
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        {tabValue === InboundStatus.SIT_PENDING ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.SIT_PLACED ? (
          <YardDateField
            source="placedDateTime"
            label="Placed Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        <TextField source="railCarNumber" label="Car/Trl No" sortable />
        <TextField source="poNumber" label="PO Number" sortable={true} />
        {tabValue === InboundStatus.SIT_PLACED ? (
          <FunctionField
            source="placedDateTime"
            label="Age"
            sortable={false}
            render={sitAgeRenderer}
          />
        ) : null}
      </Datagrid>
    ) : (
      <Datagrid rowClick="edit" hasBulkActions={true}>
        {tabValue === InboundStatus.SIT_PLACED ? <InboundStateIcon /> : null}

        {tabValue === InboundStatus.SIT_PLACED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={exceptionRenderer}
          />
        ) : null}
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        {tabValue === InboundStatus.SIT_PENDING ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.SIT_PLACED ? (
          <YardDateField
            source="placedDateTime"
            label="Placed Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        <TextField source="railCarNumber" label="Car/Trl No" sortable />
        <TextField source="poNumber" label="PO Number" sortable />
        {tabValue === InboundStatus.SIT_PLACED ? (
          <FunctionField
            source="placedDateTime"
            label="Age"
            sortable={false}
            render={sitAgeRenderer}
          />
        ) : null}

        {tabValue === InboundStatus.SIT_PENDING ? (
          <AdvanceButton
            record={props}
            newStatus={InboundStatus.SIT_PLACED}
            buttonLabel="Set Placed"
            {...props}
          />
        ) : null}
        {tabValue === InboundStatus.SIT_PLACED ? (
          <AdvanceButton
            record={props}
            newStatus={InboundStatus.RELEASED}
            buttonLabel="Set Released"
            {...props}
          />
        ) : null}
        <EditButton />
      </Datagrid>
    );
};
